import {
  PropsWithChildren,
  ReactElement,
  createContext,
  useContext
} from 'react';

type ZoneMapProps = {
  readonly [name: string]: ReactElement;
};

const ZoneMapContext = createContext<ZoneMapProps>({});

export function useZoneMap() {
  return useContext(ZoneMapContext);
}

export const ZoneMapProvider = ({
  children,
  zoneMap
}: PropsWithChildren & { readonly zoneMap: ZoneMapProps }) => {
  return (
    <ZoneMapContext.Provider value={zoneMap}>
      {children}
    </ZoneMapContext.Provider>
  );
};
